"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frequencyMap = exports.PlaylistMode = void 0;
var rrule_1 = require("rrule");
var PlaylistMode;
(function (PlaylistMode) {
    PlaylistMode["Sequential"] = "sequential";
    PlaylistMode["Shuffle"] = "shuffle";
    PlaylistMode["Single"] = "single";
    PlaylistMode["HoldOnTrue"] = "holdOnTrue";
})(PlaylistMode = exports.PlaylistMode || (exports.PlaylistMode = {}));
exports.frequencyMap = {
    yearly: rrule_1.RRule.YEARLY,
    monthly: rrule_1.RRule.MONTHLY,
    weekly: rrule_1.RRule.WEEKLY,
    daily: rrule_1.RRule.DAILY,
    hourly: rrule_1.RRule.HOURLY,
    minutely: rrule_1.RRule.MINUTELY,
    secondly: rrule_1.RRule.SECONDLY
};
